import React from "react";
import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";
import Section7 from "./Section7";
import Section8 from "./Section8";
import Section9 from "./Section9";
import Section10 from "./Section10";
import Section11 from "./Section11";
import Section12 from "./Section12";


export default function Testimonial() {
  return (
    <div id="Tiktok" className="Tiktok bg-[#F5F5F5] pt-[160px] sm:pt-0">
      <Helmet>
        <title>TikTok Marketing Agency | TikTok Ads Management Services</title>
        <meta
        name="description"
        content="Grow your brand on TikTok with Mean3. We manage ads that connect you with audiences that convert. Hire the Best Tiktok Marketing Agency Today!"
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section7 />
      <Section8 />
      <Section4 />
      <Section9 />
      <Section5 />
      <Section10 />
      <Section12 />
      <Section11 />
      <Section6 />
    </div>
  );
}
